<template>
  <v-container class="d-flex justify-center">
    <v-card flat>
      <h1>{{ $t('forbidden.title') }}</h1>

      <div class="mt-5 mb-5 d-flex justify-center">
        <v-icon class="notAllowed">$sl-stop</v-icon>
      </div>

      <p>
        <b>{{ $t('forbidden.text1') }}</b>
      </p>
      <p v-html="$t('forbidden.text2')">
        
      </p>
      <p>{{ $t('forbidden.text3') }}</p>

      <ActionButton class="mt-6" :width="'140px'" :block="false" actionIcon="$sl-arrow-left" @click="$router.push('/')"
        >{{ $t('notfound.button') }}</ActionButton
      >
    </v-card>
  </v-container>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'
// @group Common
// NotFound component
export default {
  name: 'Forbidden',
  components: {
    ActionButton
  }
}
</script>

<style scoped>
.notAllowed {
  width: 192px;
  height: 192px;
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>